// src/components/financeiro/ModalPagamento.jsx
import { useState } from "react";

export default function ModalPagamento({ parcela, onClose, onPagar }) {
  const [valorPago, setValorPago] = useState(parcela.valor);
  const [forma, setForma] = useState("pix");
  const [actionType, setActionType] = useState(null);

  const handleSubmit = async() => {
    setActionType("confirmar");
    try {
    await onPagar(parcela._id, {
      valorPago: Number(valorPago),
      formaPagamento: forma,
    });
    onClose();
    } catch (error) {
      console.error("Erro ao processar pagamento:", error);
    } finally {
      setActionType(null);
    }
  };

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <div style={{ background: "#fff", padding: 20, borderRadius: 8 }}>
        <h3>Registrar Pagamento</h3>

        <input
          type="number"
          value={valorPago}
          onChange={(e) => setValorPago(e.target.value)}
          disabled
        />

        <select value={forma} onChange={(e) => setForma(e.target.value)}>
          <option value="pix">PIX</option>
          <option value="dinheiro">Dinheiro</option>
          <option value="cartao">Cartão</option>
        </select>

        <div style={{ marginTop: 10 }}>
          <button 
            onClick={handleSubmit}
            disabled={actionType !== null}
            >
              {actionType === "confirmar" ? (
                <span className="spinner-loader"></span>
              ) : ( "Confirmar" )}
          </button>
          <button 
            onClick={onClose}
            disabled={setActionType}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}